import ReactMarkdown from 'react-markdown';
import Media from 'react-media';

import { useTheme } from '@simplywallst/ui-core';

import Carousel, { Slides, Slide } from '@/components/Carousel';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import {
  ValuesContainerRow,
  ValuesHeader,
  Value,
  ValuesContentRow,
  StyledReactMarkdown,
} from './styled';
import { OneColumnExpanded } from '../../styled';

interface Props {
  title?: string;
  subtitle?: string;
  markdownContent: string[];
}

export const Values = ({ title, subtitle, markdownContent }: Props) => {
  const theme = useTheme();
  const { isMobile, isTablet } = useUserAgent();
  const colors = [
    theme.color.chart01,
    theme.color.chart03,
    theme.color.neutral,
    theme.color.chart05,
    theme.color.chart06,
  ];
  return (
    <ValuesContainerRow justifyContent="center" bgColor="#EAF3FF">
      <OneColumnExpanded>
        <ValuesHeader data-cy-id="values">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </ValuesHeader>

        <ValuesContentRow justifyContent="center">
          {markdownContent.length > 0 && (
            <Media
              defaultMatches={isMobile || isTablet}
              query={{ maxWidth: theme.mdMaxRaw }}
            >
              {(match) => {
                if (match) {
                  return (
                    <Carousel
                      showDots
                      slidesToScroll={1}
                      totalSlides={markdownContent.length}
                    >
                      <Slides>
                        {markdownContent.map((value, i) => (
                          <Slide key={i} itemsToShow={1}>
                            <Value displayFlex colMd={10} bgColor={colors[i]}>
                              <StyledReactMarkdown>
                                <ReactMarkdown source={value} />
                              </StyledReactMarkdown>
                            </Value>
                          </Slide>
                        ))}
                      </Slides>
                    </Carousel>
                  );
                }
                return (
                  <>
                    {markdownContent.map((value, i) => (
                      <Value key={i} displayFlex colMd={4} bgColor={colors[i]}>
                        <StyledReactMarkdown>
                          <ReactMarkdown source={value} />
                        </StyledReactMarkdown>
                      </Value>
                    ))}
                  </>
                );
              }}
            </Media>
          )}
        </ValuesContentRow>
      </OneColumnExpanded>
    </ValuesContainerRow>
  );
};
